export default __webpack_public_path__ + "static/media/09-framing-questions.be045ac3.svg";